export default __webpack_public_path__ + "static/media/bg-home-page.5055ea12.svg";